import { CONFIG } from '@/global-config';
import { View403 } from '@/page-sections/error';

// ----------------------------------------------------------------------

const metadata = { title: `403 forbidden! | Error - ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <title>{metadata.title}</title>

      <View403 />
    </>
  );
}
